var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33.862 33.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35551",
    "data-name": "Path 35551",
    d: "M35.112,17.175V8.906A5.9,5.9,0,0,0,29.206,3H7.156A5.906,5.906,0,0,0,1.25,8.906v18.9a5.906,5.906,0,0,0,5.906,5.906H18.181a1.181,1.181,0,0,0,0-2.362H7.156a3.543,3.543,0,0,1-3.544-3.544V8.906A3.543,3.543,0,0,1,7.156,5.362h22.05A3.544,3.544,0,0,1,32.75,8.906v8.269a1.181,1.181,0,0,0,2.362,0Z",
    transform: "translate(0 1.006)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35552",
    "data-name": "Path 35552",
    d: "M33.931,9H2.431a1.181,1.181,0,0,0,0,2.362h31.5a1.181,1.181,0,1,0,0-2.362Z",
    transform: "translate(0 4.456)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35553",
    "data-name": "Path 35553",
    d: "M6.75,2.431V7.944a1.181,1.181,0,1,0,2.362,0V2.431a1.181,1.181,0,0,0-2.362,0Z",
    transform: "translate(3.162 0)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35554",
    "data-name": "Path 35554",
    d: "M15.75,2.431V7.944a1.181,1.181,0,0,0,2.362,0V2.431a1.181,1.181,0,0,0-2.362,0Z",
    transform: "translate(8.337 0)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35555",
    "data-name": "Path 35555",
    d: "M20.519,12.25a8.269,8.269,0,1,0,8.269,8.269A8.272,8.272,0,0,0,20.519,12.25Zm0,2.362a5.906,5.906,0,1,1-5.906,5.906A5.908,5.908,0,0,1,20.519,14.612Z",
    transform: "translate(6.325 6.325)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35556",
    "data-name": "Path 35556",
    d: "M15.1,19.091l2.362,2.362a1.18,1.18,0,0,0,1.669,0l3.937-3.937A1.181,1.181,0,1,0,21.4,15.846l-3.1,3.1-1.528-1.526A1.181,1.181,0,1,0,15.1,19.091Z",
    transform: "translate(7.763 8.194)",
    fill: "#96006b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceTracking);
export default __webpack_public_path__ + "static/media/attendanceTracking.134666ca39bb874aafa25f737f2c92a0.svg";
export { ForwardRef as ReactComponent };